import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { BsButton } from '../../collection/bootstrap/BootstrapComponents';
import DataTable from '../../collection/DataTable';
import TableHandler from '../../collection/TableHandler';
import NombreFilter from '../../components/filters/NombreFilter';
import ClienteModal from '../../components/modals/ClienteModal';
import FloatingAddButton from '../../components/project/FloatingAddButton';
import { apiDelete, apiForm } from '../../utils/api';
import { sortableString, generateFormData } from '../../utils/functions';

export default function Clientes(props) {
    // filter
    const defaultFilter = {
        nombre: null
    };
    let filter = generateFormData(defaultFilter);

    // api calls
    const updateData = async newFilter => {
        filter = newFilter ? newFilter : filter;
        return await apiForm("clientes/table", filter);
    };
    const deleteRow = async id => await apiDelete("clientes/delete/" + id);

    // render
    return <>
        <h2>Clientes</h2>
        <TableHandler
            onUpdate={updateData}
            onDelete={deleteRow}
            elementText="el cliente">
            <NombreFilter
                className="my-3" fem
                defaultValue={defaultFilter} />
            <ClientesTable />
        </TableHandler>
    </>;
}

function ClientesTable(props) {
    // table columns
    const columns = [
        {
            name: "Nombre",
            selector: row => sortableString(row.Name),
            format: row => row.Name,
            sortable: true
        }
    ];
    // table buttons
    const buttons = <>
        <BsButton variant="secondary" size="sm" onClick={props.onEdit}><FontAwesomeIcon icon={faEdit} /></BsButton>
        <BsButton variant="danger" size="sm" onClick={props.onDelete}><FontAwesomeIcon icon={faTrash} /></BsButton>
    </>;

    // render
    return <>
        <DataTable responsive columns={columns} data={props.data} buttons={buttons} pagination defaultSortFieldId={1} />
        {props.formOpen && (
            <ClienteModal
                show={props.formOpen}
                onHide={props.onFormClose}
                idCliente={props.formId}
            />
        )}
        <FloatingAddButton onClick={props.onNew} />
    </>;
}
